// @general/mail — frontend surface.
//
// Two things live here:
//
//   · the company's outgoing mail settings (Ajustes → Correo saliente): the
//     mailboxes the INSTANCE sends from — notices, reports, the portal;
//
//   · each person's mail client: their own accounts, a full inbox, the
//     composer that any screen can open («Enviar por email» on an invoice),
//     and the conversations linked to every record of the ERP.

import { unreadMail } from './client/store'

export const routes = [
  {
    path: '/settings/mail',
    name: 'settings-mail',
    component: () => import('./views/MailSettingsView.vue'),
    // Leer para ver desde dónde sale el correo; escribir lo pide cada botón por
    // su cuenta, porque dar de alta un buzón es cambiar una credencial.
    meta: { permission: 'settings:read', title: 'mailSettings.title' },
  },
  {
    path: '/mail',
    name: 'mail',
    component: () => import('./views/MailView.vue'),
    // The screen keeps where one is in the URL (account, folder, open…) and
    // rewrites it on every click: it must not be remounted each time.
    meta: { permission: 'mail:use', title: 'mailClient.title', ownsQuery: true },
  },
  {
    path: '/mail/accounts',
    name: 'mail-accounts',
    component: () => import('./views/MailAccountsView.vue'),
    meta: { permission: 'mail:use', title: 'mailClient.accounts.title' },
  },
  {
    // A conversation opened from a record it is linked to. No permission of
    // its own: the server opens it for its owner and for whoever can see a
    // record it is linked to, and answers 404 to anybody else.
    path: '/mail/view/:id',
    name: 'mail-view',
    component: () => import('./views/MailMessageView.vue'),
    meta: { title: 'mailClient.shared.title' },
  },
  {
    // A file that came by email, opened from a record it is linked to: what
    // it is, where it came from, who linked it and to what. Same rule as
    // above — the server answers 404 to whoever cannot see one of its records.
    path: '/mail/file/:linkId',
    name: 'mail-file',
    component: () => import('./views/MailFileView.vue'),
    meta: { title: 'mailClient.linkedFile.title' },
  },
]

export const navigation = [
  // In the platform block, leading it right after the notifications: it is
  // platform, not a module the client bought. The count is the unread in every
  // inbox of the person, kept current by MailComposeHost.
  { to: '/mail', labelKey: 'mailClient.title', permission: 'mail:use', icon: 'mail', group: 'platform', order: 12, badge: unreadMail },
]

// Mounted once by the app's layout: the composer over any screen.
export { default as MailComposeHost } from './client/MailComposeHost.vue'
// For a module's record page with no «related» tabs: its conversations and
// the «Send by email» button.
export { default as RecordMail } from './client/RecordMail.vue'
// «Enviar por email» on a record's own header.
export { default as SendByEmailButton } from './client/SendByEmailButton.vue'
// For a module's own button: open the composer on one of its records.
export { useMailCompose, useMailStore } from './client/store'

export default { routes, navigation }
